// Poki SDK mock
// if (location.hostname === "127.0.0.1" || location.hostname === "localhost") {
//   console.info("PokiSDK mock enabled");
//   PokiSDK = {
//     gameplayStart: () => console.info("gamePlayStart() mock"),
//     gameplayStop: () => console.info("gamePlayStop() mock"),
//     gameLoadingFinished: () => console.info("gameLoadingFinished() mock"),
//     commercialBreak: () => console.info("comercialBreak")
//   }
// }


let randomValueIndex = 0;
const getNextRandomValue = () => {
  const rand = randomValues[randomValueIndex];
  randomValueIndex = randomValueIndex < randomValues.length - 1 ? randomValueIndex + 1 : 0; 
  return rand;
}

// canvas
const canvas = document.getElementById("game");
const ctx = canvas.getContext("2d");

const createChatMessage = (text, posX, posY, timeout = 1500, color) => {
  chatMessages.push({
    id: Math.random(),
    text,
    posX,
    posY,
    creationDate: Date.now(),
    timeout,
    color
  });
};

const destroyChatMessage = index => {
  delete chatMessages[index];
  chatMessages = chatMessages.filter((c) => c);
};

const startAttackChargeEffect = () => {
  attackLoaderValue = 10;
};

const endAttackChargeEffect = () => {
  chargedAttackCooldown = true;
};

const removeCorpse = (index) => {
  delete corpses[index];
  corpses = corpses.filter((c) => c);
};

// make objets fall
const updateGravity = () => {
  if (speedUp !== 0) {
    playerY -= speedUp;
    speedUp -= accelerationUp;
  }
  if (playerY > GROUND_HEIGHT) {
    speedUp = 0;
    playerY = GROUND_HEIGHT;
  }
  if (items?.length > 0) {
    items.forEach((item) => {
      item.posY += item.speedUp;
      item.speedUp += accelerationUp;
      if (item.posY > GROUND_HEIGHT) {
        item.speedUp = 0;
        item.posY = GROUND_HEIGHT;
      }
    });
  }
};

// make player recoil (when hit)
const updateRecoil = () => {
  if (recoilSpeed !== 0) {
    if (!(recoilSpeed < 0 && playerX < 10 || recoilSpeed > 0 && playerX > GAME_WIDTH - 10)) {
      playerX += recoilSpeed;
      recoilSpeed =
      recoilSpeed > 0
      ? recoilSpeed - recoilAcceleration
      : recoilSpeed + recoilAcceleration;
    }
  }
  if (recoilSpeed < 0.2 && recoilSpeed > -0.2) {
    recoilSpeed = 0;
  }
  // enemies
  enemies.forEach(e => {
    if (e.recoilSpeed !== 0) {
      if (!(e.recoilSpeed < 0 && e.posX < 10 || e.recoilSpeed > 0 && e.posX > GAME_WIDTH - 10)) {
      e.posX += e.recoilSpeed;
      e.recoilSpeed =
        e.recoilSpeed > 0
          ? e.recoilSpeed - recoilAcceleration
          : e.recoilSpeed + recoilAcceleration;
      }
    }
    if (e.recoilSpeed < 0.2 && e.recoilSpeed > -0.2) {
      e.recoilSpeed = 0;
    }
  })
};

// move player to the sides
const movePlayer = () => {
  if (leftIsPressed && playerX > 20) {
    playerX -= PLAYER_SPEED;
  } else if (rightIsPressed && playerX < GAME_WIDTH - 20) {
    playerX += PLAYER_SPEED;
  }
};

const shot = (timePressed) => {
  if (mana >= SPELL_COSTS.SPELL) {
    mana -= SPELL_COSTS.SPELL;
    if (chargedAttackCooldown || timePressed < 1000) {
      startParticleSystem(
        shots.length,
        playerDirection === DIRECTION.LEFT ? playerX - 35 : playerX + 35,
        playerY + 15,
        { r: 0, g: 255, b: 0 },
        playerDirection === DIRECTION.LEFT ? "right" : "left",
        shots,
        {
          initTtl: 50,
          speed: 0.7,
          maxParticles: 40,
          headParticleColor: "white"
        }
        );
        if (playerIsPoweredUp) {
          startParticleSystem(
            shots.length,
            playerDirection === DIRECTION.LEFT ? playerX - 37 : playerX + 37,
            playerY + 5,
          { r: 0, g: 255, b: 0 },
          playerDirection === DIRECTION.LEFT ? "right" : "left",
          shots,
          {
            initTtl: 50,
            speed: 0.7,
            maxParticles: 40,
            headParticleColor: "white"
          }
        );
      }
    } else {
      startParticleSystem(
        shots.length,
        playerDirection === DIRECTION.LEFT ? playerX - 35 : playerX + 35,
        playerY + 15,
        { r: 0, g: 255, b: 0 },
        playerDirection === DIRECTION.LEFT ? "right" : "left",
        shots,
        {
          initTtl: 50,
          speed: 0.4,
          maxParticles: 60,
          headParticleColor: "white",
          initSize: 8,
          systemSpeed: 4
        },
        {
          isBigShot: true
        }
        );
        if (playerIsPoweredUp) {
          startParticleSystem(
            shots.length,
            playerDirection === DIRECTION.LEFT ? playerX - 37 : playerX + 37,
            playerY + 5,
          { r: 0, g: 255, b: 0 },
          playerDirection === DIRECTION.LEFT ? "right" : "left",
          shots,
          {
            initTtl: 50,
            speed: 0.4,
            maxParticles: 60,
            headParticleColor: "white",
            initSize: 8,
            systemSpeed: 4
          },
          {
            isBigShot: true
          }
        );
      }
    }
  }
};

const updateShots = () => {
  shots.forEach((p, index) => {
    if (p.init.direction === "left") {
      p.init.initX += p.init.systemSpeed;
    } else if (p.init.direction === "right") {
      p.init.initX -= p.init.systemSpeed;
    }
    if (p.init.initX > GAME_WIDTH || p.init.initX < 0) {
      removeParticleSystem(index, shots);
    }
  });
};

const spawnEnemies = (number) => {
  enemiesSpawnedThisWave += number;
  for (let i = 0; i < number; i++) {
    enemies.push(generateEnemy());
  }
};

const spawnBoss = () => {
  enemies.push(generateBoss());
};

const spawnItems = (number) => {
  for (let i = 0; i < number; i++) {
    items.push(generateItem());
  }
};

const randomDrop = (posX, posY, isBoss) => {
  if (isBoss) {
    if (Math.random() < 0.5) {
      items.push({
        id: Math.random(),
        posX: posX + 10,
        posY: posY - 100,
        kind: ITEMS.MANA,
        speedUp: -2,
      })
    }
    if (Math.random() < 0.5) {
      items.push({
        id: Math.random(),
        posX,
        posY: posY - 10,
        kind: ITEMS.HEAL,
        speedUp: -2,
      })
    }
  } else {
    if (Math.random() < 0.2) {
      items.push({
        id: Math.random(),
        posX,
        posY: posY - 100,
        kind: ITEMS.MANA,
        speedUp: -2,
      })
    }
  }
};

const killEnemy = (enemyId) => {
  enemies.forEach((e, index) => {
    if (e.id === enemyId) {
      corpses.push({
        posX: e.posX,
        posY: e.posY,
        isBoss: e.isBoss
      });
      randomDrop(e.posX, e.posY, e.isBoss);
      delete enemies[index];
    }
  });
  enemies = enemies.filter((e) => e);
  killCount += 1;
};

const raiseSkeleton = () => {
  if (mana >= SPELL_COSTS.RAISE) {
    let raised;
    corpses.forEach((corpse, index) => {
      if (Math.abs(playerX - corpse.posX) < 20) {
        raised = { corpse, index };
      }
    });
    if (raised) {
      const skeleton = generateSkeleton(raised.corpse.posX);
      skeleton.isBoss = raised.corpse.isBoss;
      if (skeleton.isBoss) {
        skeleton.hp = 7;
        skeleton.maxHP = 7;
        skeleton.attackSpeed = 3000;
      }
      skeletons.push(skeleton);
      removeCorpse(raised.index);
      mana -= SPELL_COSTS.RAISE;
      createChatMessage(SKELETON_GREETINGS[Math.floor(Math.random() * SKELETON_GREETINGS.length)], skeleton.posX, skeleton.posY - 20);
      skeletonsRaised += 1;
    }
  }
};

const evocation = () => {
  if (lives > 1 && mana < 100) {
    playerIsEvocating = true;
    mana = Math.min(mana + 50, 100);
    lives -= 1;
    startParticleSystem(
      particleEffects.length,
      playerDirection === DIRECTION.RIGHT ? playerX + 30 : playerX - 45,
      GROUND_HEIGHT + 5,
      { r: 50, g: 50, b: 255 },
      "up",
      particleEffects,
      {
        initSize: 15,
        initTtl: 180,
        speed: 0.15,
        maxParticles: 80
      }
    );
    setTimeout(() => {
      playerIsEvocating = false;
      particleEffects = [];
    }, 3000);
  }
};

const destroySkeleton = (skeletonId) => {
  delete skeletons[skeletons.findIndex((s) => s.id === skeletonId)];
  skeletons = skeletons.filter((s) => s);
};

const destroyItem = (itemId) => {
  delete items[items.findIndex((s) => s.id === itemId)];
  items = items.filter((s) => s);
};

const initWave = () => {
  skeletons.forEach(s => {
    s.hp = s.maxHP;
  });
  corpses = [];
  if (waveNumber % BOSS_FREQUENCY === 0) {
    spawnEnemies(waveNumber - 1);
    spawnBoss();
  } else {
    spawnEnemies(waveNumber);
  }
};

const initRest = () => {
  restCountdown = REST_COUNTDOWN;
  spawnItems(Math.floor(Math.random() * 5));
  playerIsPoweredUp = false;
};

// run AI
const AIStep = () => {
  const now = Date.now();
  enemies.forEach((enemy) => {
    const target = skeletons.find(
      (s) => Math.abs(s.posX - enemy.posX) < MELEE_RANGE
    );
    const playerContact =
      Math.abs(playerX - enemy.posX) < MELEE_RANGE &&
      Math.abs(playerY - enemy.posY) < MELEE_RANGE;
    if (target) {
      if (now - enemy.lastAttack > enemy.attackSpeed) {
        enemy.lastAttack = now;
        target.hp -= 1;
        enemy.isAttacking = true;
        if (target.hp <= 0) {
          destroySkeleton(target.id);
        }
      }
    } else if (playerContact) {
      if (now - enemy.lastAttack > enemy.attackSpeed) {
        enemy.lastAttack = now;
        lives -= 1;
        particleEffects = [];
        enemy.isAttacking = true;
        recoilSpeed = playerX < enemy.posX ? -7 : 7;
        if (lives <= 0) {
          state = STATES.LOSE;
          PokiSDK.gameplayStop();
        }
      }
    } else {
      if (enemy.speed > 0 && playerX < enemy.posX || enemy.speed < 0 && playerX > enemy.posX) {
          if (enemy.stepsToReact) {
            enemy.stepsToReact -= 1;
          } else {
            enemy.stepsToReact = enemy.reactionTimeInSteps;
          }
          if (enemy.stepsToReact === 0) {
            enemy.speed = -enemy.speed;
          }
      } else {
        enemy.posX += enemy.speed;
      }
    }
  });
  skeletons.forEach((skeleton) => {
    const target = enemies.find((e) => Math.abs(e.posX - skeleton.posX) < MELEE_RANGE);
    if (target) {
      if (now - skeleton.lastAttack > skeleton.attackSpeed) {
        skeleton.lastAttack = now;
        target.hp -= 1;
        skeleton.isAttacking = true;
        target.recoilSpeed = skeleton.posX < target.posX ? 7 : -7;
        if (target.hp <= 0) {
          killEnemy(target.id);
        }
      }
    } else {
      if (skeleton.posX > playerX && enemies.length > 0 && skeleton.posX < GAME_WIDTH - 60) {
        skeleton.posX += skeleton.speed;
      } else if (skeleton.posX > playerX + 5 && enemies.length === 0) {
        skeleton.posX -= skeleton.speed;
      } else if (skeleton.posX < playerX && enemies.length > 0 && skeleton.posX > 60) {
        skeleton.posX -= skeleton.speed;
      } else if (skeleton.posX < playerX - 5 && enemies.length === 0) {
        skeleton.posX += skeleton.speed;
      }
    }
  });
};

const checkColisions = () => {
  shots.forEach((p, index) => {
    const enemy = enemies.find(
      (e) =>
        Math.abs(e.posX - p.init.initX) < 30 &&
        Math.abs(e.posY - p.init.initY) < 30
    );
    if (enemy) {
      enemy.hp -= p.init.metadata.isBigShot ? 2 : 1;
      removeParticleSystem(index, shots);
      enemy.recoilSpeed = playerX < enemy.posX ? 7 : -7;
      if(enemy.hp === 0) {
        killEnemy(enemy.id);
      }
    }
  });
  items.forEach((item) => {
    if (
      Math.abs(item.posX - playerX) < 30 &&
      Math.abs(item.posY - playerY) < 30
    ) {
      if (item.kind === ITEMS.MANA) {
        createChatMessage("+25", playerX, playerY - 20, 1000, "deepskyblue");
        mana = Math.min(100, mana + 25);
      } else if (item.kind === ITEMS.HEAL && lives < maxLives) {
        lives += 1;
      } else if (item.kind === ITEMS.POWERUP && !playerIsPoweredUp) {
        playerIsPoweredUp = true;
      } else if (item.kind === ITEMS.EXTRA_LIFE) {
        maxLives += 1;
        lives += 1;
      }
      destroyItem(item.id);
    }
  });
};

// ACTIONS ********
const jump = () => {
  if (speedUp === 0) {
    speedUp = 6;
  }
  keyHaveBeenPressedOnce.up = true;
};

const firePressed = () => {
  if (!fireStartedAt) {
    if (!chargedAttackCooldown) {
      startAttackChargeEffect();
    }
    fireStartedAt = Date.now();
  }
};

const fire = (timePressed) => {
  if (!lastFireAt || Date.now() - lastFireAt > 300) {
    shot(timePressed);
    endAttackChargeEffect();
    keyHaveBeenPressedOnce.f = true;
    lastFireAt = Date.now();
  }
}

const raise = () => {
  raiseSkeleton();
  keyHaveBeenPressedOnce.r = true;
}

const evocate = () => {
  if (speedUp === 0) {
    evocation();
    keyHaveBeenPressedOnce.e = true;
  }
}

const moveLeft = () => {
  playerDirection = DIRECTION.LEFT;
  leftIsPressed = true;
  rightIsPressed = false;
  keyHaveBeenPressedOnce.left = true;
}

const moveRight = () => {
  playerDirection = DIRECTION.RIGHT;
  rightIsPressed = true;
  leftIsPressed = false;
  keyHaveBeenPressedOnce.right = true;
}

const pause = () => {
  state = STATES.PAUSED;
}

const resume = () => {
  state = STATES.RUNNING;
}
// ********

const initInteraction = () => {
  document.getElementById("game").addEventListener("touchstart", ev => {
    if (interactionEnabled) {
      if (state === STATES.RUNNING && !playerIsEvocating) {
        const { top, left } = document.getElementById("game").getBoundingClientRect();
        const btnOffsetX = 30 * window.scaleFactor;
        const btnOffsetY = 30 * window.scaleFactor;
        const clientX = ev.changedTouches[0].clientX;
        const clientY = ev.changedTouches[0].clientY;
        const buttonsWithPause = buttons.concat({
          x: GAME_WIDTH - 300,
          y: 20,
          action: state.STATES_RUNNING ? pause() : resume()
        });
        buttonsWithPause.forEach(btn => {
          const dist = Math.sqrt(Math.pow((btn.x + btnOffsetX) * window.scaleFactor - clientX + left, 2) + Math.pow((btn.y + btnOffsetY) * window.scaleFactor - clientY + top, 2));
          if (dist < 40*window.scaleFactor) {
            if (btn.action.name === "fire") {
              firePressed();
            } else {
              btn.action();
            }
          }
        })
      } else if (state === STATES.TITLE) {
    // UNCOMMENT TO ENABLE ADS
          // pause your game here if it isn't already
          PokiSDK.commercialBreak(() => {
            // you can pause any background music or other audio here
            document.getElementById("title-music").stop();
            interactionEnabled = false;
          }).then(() => {
            state = STATES.RUNNING;
            playerX = GAME_WIDTH / 3;
            interactionEnabled = true;
            PokiSDK.gameplayStart();
            // if the audio was paused you can resume it here (keep in mind that the function above to pause it might not always get called)
            // continue your game here
          });
      } else if (state === STATES.LOSE) {
            // UNCOMMENT TO ENABLE ADS
            PokiSDK.commercialBreak(() => {
              // you can pause any background music or other audio here
              interactionEnabled = false;
            }).then(() => {
            location.reload();
          });
      }
    }
  });

  document.addEventListener("touchend", ev => {
    if (interactionEnabled) {
      if (state === STATES.RUNNING && !playerIsEvocating) {
        const { top, left } = document.getElementById("game").getBoundingClientRect();
        const btnOffsetX = 30 * window.scaleFactor;
        const btnOffsetY = 30 * window.scaleFactor;
        const clientX = ev.changedTouches[0].clientX;
        const clientY = ev.changedTouches[0].clientY;
        buttons.forEach(btn => {
          const dist = Math.sqrt(Math.pow((btn.x + btnOffsetX) * window.scaleFactor - clientX + left, 2) + Math.pow((btn.y + btnOffsetY) * window.scaleFactor - clientY + top, 2));
          if (dist < 40*window.scaleFactor) {
            if (btn.action.name === "moveLeft" || btn.action.name === "moveRight") {
              leftIsPressed = false;
              rightIsPressed = false;                    
            } else if (btn.action.name === "fire") {
              fire(Date.now() - fireStartedAt);
              fireStartedAt = null;
            }
          }
        })
      }
    }
  });

  document.addEventListener("keydown", (ev) => {
    if (interactionEnabled) {
      if (state === STATES.LOSE) {
        if (ev.key === "Enter") {
          // UNCOMMENT TO ENABLE ADS
           PokiSDK.commercialBreak(() => {
               // you can pause any background music or other audio here
               interactionEnabled = false;
             }).then(() => {
             location.reload();
           });
        }
      } else if (state !== STATES.TITLE && state !== STATES.PAUSED && !playerIsEvocating) {
        switch (ev.key) {
          // arrows
          case "ArrowLeft":
            moveLeft();
            break;
          case "ArrowUp":
            jump();
            break;
          case "ArrowRight":
            moveRight();
            break;
          case "f":
          case "F":
            firePressed();
          break;
          case "r":
          case "R":
            raise();
          break;
          case "e":
          case "E":
            evocate();
          break;
          case "p":
          case "P":
            if (state === STATES.RUNNING) {
              pause();
            } else if (state === STATES.PAUSED) {
              resume();
            }
          break;
        }
      } else if (state === STATES.TITLE) {
        if (ev.key === "Enter") {
        // UNCOMMENT TO ENABLE ADS
          // pause your game here if it isn't already
         PokiSDK.commercialBreak(() => {
           // you can pause any background music or other audio here
           document.getElementById("title-music").stop();
           interactionEnabled = false;
         }).then(() => {
           state = STATES.RUNNING;
           playerX = GAME_WIDTH / 3;
           interactionEnabled = true;
           PokiSDK.gameplayStart();
           // if the audio was paused you can resume it here (keep in mind that the function above to pause it might not always get called)
           // continue your game here
         });
        }
      }
    }
  });
  document.addEventListener("keyup", (ev) => {
    if (state === STATES.RUNNING) {
      switch (ev.key) {
        case "ArrowLeft":
        case "ArrowRight":
          leftIsPressed = false;
          rightIsPressed = false;
          break;
        case "f":
        case "F":
          fire(Date.now() - fireStartedAt);
          fireStartedAt = null;
        break;
      }
    }
  });
};

const gameLoop = () => {
  if (state !== STATES.PAUSED) {
  if (state === STATES.TITLE) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawStars();
    drawTitle();
  } else if (state === STATES.LOSE) {
    // draw game over overlay
    drawGameOver();
  } else {
    if (loop % 2 === 0 && state === STATES.RUNNING) {
      AIStep();
      checkColisions();
      if (enemies.length === 0 && restCountdown === 0) {
        initRest();
      }
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    drawStars();
    drawMoon();
    drawPath();
    drawLandscape();
    drawCorpses();
    drawSkeletons();
    drawPlayer(playerX, playerY);
    drawAttackChargeLoader();
    updateGravity();
    updateRecoil();
    movePlayer();
    updateShots();
    drawEnemies();
    drawItems();
    drawMessages();
    drawUI();
    drawHints();
  }
  updateParticleSystems(shots);
  updateParticleSystems(particleEffects);
  if (loop % 20 === 0) {
    // mana increment
    const now = Date.now();
    if (now - manaLastCheck > 1000 && mana < 100) {
      mana += 1;
      manaLastCheck = now;
    }
    // countdown
    if (enemies.length === 0 && now - restCountdownLastCheck > 1000) {
      restCountdown -= 1;
      restCountdownLastCheck = now;
      if (restCountdown === 0) {
        items = [];
        waveNumber += 1;
        initWave();
      }
    }
    enemies.forEach(e => {
      e.isAttacking = false;
    });    
    skeletons.forEach(s => {
      s.isAttacking = false;
    });
  }
  if (loop % 3 === 0) {
    const now = Date.now();
    // animations
    if (now - animationLastCheck > 100) {
      animationLastCheck = now;
      animShieldValue += animShieldInc;
      if (animShieldValue > animShieldMax || animShieldValue < animShieldMin) {
        animShieldInc = -animShieldInc;
      }
    }
    // attack loader
    if (chargedAttackCooldown) {
      if (now - loaderLastCheck > 100) {
        if (attackLoaderValue > 0) {
          attackLoaderValue -= 1;
        } else {
          chargedAttackCooldown = false;
        }
        loaderLastCheck = now;
      }
    } else {
      if (now - loaderLastCheck > 100 && attackLoaderValue > 0 && attackLoaderValue < 100) {
        attackLoaderValue += 11;
        loaderLastCheck = now;
      }
    }
    
  }
  if (loop % 1000 === 0 && enemies.length > 0) {
    if (enemiesSpawnedThisWave < waveNumber * 2) { // continue spawning enemies till a limit
      spawnEnemies(Math.floor(waveNumber/2));
    }
  }
  loop++;
}
window.requestAnimationFrame(gameLoop);
};

const initGame = () => {
  buttons = [
    {
      x: GAME_WIDTH - 200,
      y: GAME_HEIGHT - 165,
      text: "J",
      action: jump,
      enableCondition: () => !playerIsEvocating
    },   
    {
      x: GAME_WIDTH - 100,
      y: GAME_HEIGHT - 80,
      text: "F",
      action: fire,
      enableCondition: () => (mana > SPELL_COSTS.SPELL) && !playerIsEvocating
    },    
    {
      x: GAME_WIDTH - 200,
      y: GAME_HEIGHT - 80,
      text: "R",
      action: raise,
      enableCondition: () => (mana > SPELL_COSTS.RAISE) && !playerIsEvocating
    },
    {
      x: GAME_WIDTH - 300,
      y: GAME_HEIGHT - 80,
      text: "E",
      action: evocate,
      enableCondition: () => (lives > 1) && mana < 100 && !playerIsEvocating
    },
    {
      x: 50,
      y: GAME_HEIGHT - 80,
      text: "<",
      action: moveLeft,
      enableCondition: () => !playerIsEvocating
    },    
    {
      x: 180,
      y: GAME_HEIGHT - 80,
      text: ">",
      action: moveRight,
      enableCondition: () => !playerIsEvocating
    }
  ];
  generateStarBackground(200);
  initInteraction();
  play();
  window.requestAnimationFrame(gameLoop);
};

const play = () => {
  initWave();
};

window.addEventListener("load", () => {
  // disable page scrolling
  window.addEventListener('keydown', ev => {
    if (['ArrowDown', 'ArrowUp', ' '].includes(ev.key)) {
        ev.preventDefault();
    }
  });

  window.addEventListener('wheel', ev => ev.preventDefault(), { passive: false });

  initGame();
  PokiSDK.gameLoadingFinished();
});
